import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, Form, Row, Col, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";
import Select from 'react-select';


const ViewScontact = () => {
  const { id } = useParams();
  const { id2 } = useParams();

  const navigate = useNavigate();
  const { pointindex } = useParams();
  const [contactname, setContactname] = useState("");
  const [company, setCompany] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}supplierContactPerson/findById/${id2}`, {
          headers: authHeader(),
        });
        const contactData = response.data;
        console.log('Scontact', contactData);
        setCompany({ value: contactData.supplier.id, label: contactData.supplier.companyname });
        setContactname(contactData.contactname);
        setMobileno(contactData.mobileno);
        setEmail(contactData.email);
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch contact details. Please try again.',
        });
      }
    };

    if (id2) {
      fetchData();
    }
  }, [id2]);

  const handleSubmit = async () => {
    setIsLoading(true);

    const contactData = {
      contactname,
      // company,
      mobileno,
      email,
      supplier: { id }
    };

    try {
      const response = await axios.put(`${BASE_URL}supplierContactPerson/update/${id2}`, contactData, {
        headers: authHeader(),
      })
      console.log(response.data);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Contact updated successfully!',
      });

      navigate(`/contactTable/${id}/${pointindex}`);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'An error occurred. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getItem = (id2) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${BASE_URL}supplierContactPerson/delete/${id2}`, {
          headers: authHeader(),
        })

          .then(response => {
            console.log('brand', response);
            if (response.data.length === 0) {
              Swal.fire(
                'Warning',
                'supplier present in another module. Delete operation has been cancelled.',
                'warning'
              );
            } else {
              console.log(response.data);
              navigate(`/contactSTable/${id}/${pointindex}`);
              Swal.fire(
                'Deleted!',
                'Deleted successfully.',
                'success'
              );
            }
          })
          .catch((error) => {
            Swal.fire(
              'Error',
              error.response.data,
              'error'
            );
          });
      }
    });
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW CONTACT</h6>
          <div className="view-buttons">
            <Link><button className="button-70" onClick={() => getItem(id2)}>DELETE</button></Link>
            <Link to={`/contactSEdit/${id}/${id2}/${pointindex}`}><button className="button-70">EDIT</button></Link>
            <Link to={`/contactSTable/${id}/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group controlId="company">
                  <Form.Label>Company </Form.Label>
                  <Select
                    value={company}
                    // onChange={handlecompanyChange}
                    // options={companyOptions}
                    // placeholder="Select Company"
                    isDisabled
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formContactname">
                  <Form.Label>Contact Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={contactname}
                    onChange={(e) => setContactname(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formMobileno">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={mobileno}
                    onChange={(e) => setMobileno(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* <button
              className="button-70"
              type="button"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? <Spinner animation="border" size="sm" /> : 'SUBMIT'}
            </button> */}
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ViewScontact;
